/**
 * Сохранение файлов: диалоги только синхронно с жестом пользователя,
 * запись blob — после async-генерации.
 */

export function supportsSaveFilePicker() {
  return typeof window.showSaveFilePicker === 'function';
}

export function supportsDirectoryPicker() {
  return typeof window.showDirectoryPicker === 'function';
}

export function downloadBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 3000);
}

export async function pickSaveFile({ suggestedName, description, accept }) {
  const handle = await window.showSaveFilePicker({
    suggestedName,
    types: [{ description, accept }],
  });
  return handle;
}

export async function pickWritableDirectory() {
  return window.showDirectoryPicker({ mode: 'readwrite' });
}

export async function writeBlobToFileHandle(fileHandle, blob) {
  const writable = await fileHandle.createWritable();
  await writable.write(blob);
  await writable.close();
}

export async function writeBlobToDirectory(directoryHandle, fileName, blob) {
  const fileHandle = await directoryHandle.getFileHandle(fileName, { create: true });
  await writeBlobToFileHandle(fileHandle, blob);
}

/**
 * Запись blob без открытия диалога (после генерации).
 * @returns {'saved'|'downloaded'}
 */
export async function persistBlob(blob, fileName, {
  fileHandle = null,
  directoryHandle = null,
} = {}) {
  if (directoryHandle) {
    try {
      await writeBlobToDirectory(directoryHandle, fileName, blob);
      return 'saved';
    } catch (err) {
      console.warn('Не удалось записать в выбранную папку, сохраняем в загрузки:', err.message);
      downloadBlob(blob, fileName);
      return 'downloaded';
    }
  }
  if (fileHandle) {
    try {
      await writeBlobToFileHandle(fileHandle, blob);
      return 'saved';
    } catch (err) {
      console.warn('Не удалось записать в выбранный файл, сохраняем в загрузки:', err.message);
      downloadBlob(blob, fileName);
      return 'downloaded';
    }
  }
  downloadBlob(blob, fileName);
  return 'downloaded';
}

export function isAbortError(err) {
  return err && err.name === 'AbortError';
}

/**
 * Сохранение blob (без picker — handle задаёт вызывающий код до async).
 * @returns {Promise<boolean>} false только при отмене picker снаружи; здесь всегда true если blob записан/скачан
 */
export async function saveBlobAsFile(
  blob,
  suggestedName,
  _description,
  _accept,
  directoryHandle = null,
  fileHandle = null,
) {
  await persistBlob(blob, suggestedName, { fileHandle, directoryHandle });
  return true;
}
